const viteEnv = import.meta.env ?? {};

export const GTM_ID = viteEnv.VITE_GTM_ID || process.env.VITE_GTM_ID || 'GTM-K9CPTKN9';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

export const isLocalHostname = (hostname?: string): boolean => {
  const value = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  if (!value) {
    return false;
  }

  return LOCAL_HOSTNAMES.has(value.toLowerCase());
};

export const isAnalyticsProduction = (): boolean =>
  viteEnv.VITE_NODE_ENV === 'PRODUCTION' || process.env.VITE_NODE_ENV === 'PRODUCTION';

export const isAnalyticsEnabled = (): boolean =>
  Boolean(GTM_ID) && isAnalyticsProduction() && !isLocalHostname();

const LOCALHOST_GUARD =
  "if(['localhost','127.0.0.1','[::1]'].includes(location.hostname.toLowerCase()))return;";

export const getGtmScriptSrc = (): string => {
  if (isAnalyticsProduction()) {
    return '/ax/';
  }

  return 'https://www.googletagmanager.com/gtm.js';
};

export const getGtmInlineScript = (): string => {
  const src = getGtmScriptSrc();
  const loader = src.endsWith('/ax/') ? `'${src}?id='+i+dl` : `'${src}?id='+i+dl`;

  return `(function(w,d,s,l,i){${LOCALHOST_GUARD}w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=${loader};f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
};

export const getAnonymousIdPreloadScript = (): string =>
  `(function(){try{${LOCALHOST_GUARD}window.dataLayer=window.dataLayer||[];var k='anonymous_id';var id=localStorage.getItem(k);if(!id){id=(crypto.randomUUID&&crypto.randomUUID())||'anon-'+Date.now();localStorage.setItem(k,id);}window.dataLayer.push({anonymous_id:id});var cap='analytics_initial_captured';if(!sessionStorage.getItem(cap)){localStorage.setItem('analytics_initial_page_url',location.href);localStorage.setItem('analytics_initial_referrer',document.referrer||'');sessionStorage.setItem(cap,'1');}sessionStorage.removeItem('analytics_first_pv_fired');}catch(e){}})();`;
